/*
 * MatchBoox beeldbewaking
 * Vangnet voor productafbeeldingen: als een afbeelding in een productkaart of
 * productlink niet laadt (of nog geen bron heeft), wordt productafbeelding 1
 * rechtstreeks uit Shopify opgehaald. Werkende afbeeldingen worden nooit aangeraakt.
 */
(() => {
  if (window.mbImageGuard) return;
  window.mbImageGuard = true;

  const cache = new Map();
  const handleOf = (img) => {
    const link = img.closest('a[href*="/products/"]');
    const match = (link?.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (match) return decodeURIComponent(match[1]);
    return img.closest('[data-product-handle]')?.dataset.productHandle || '';
  };
  const readProduct = (handle) =>
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);
  const firstImage = (handle) => {
    if (!cache.has(handle)) {
      cache.set(handle, (async () => {
        let product = await readProduct(handle);
        if (!product) {
          /* Oude of omgeleide link: volg de redirect naar het echte product. */
          const page = await fetch('/products/' + encodeURIComponent(handle), { method: 'GET' }).catch(() => null);
          const target = (page?.url || '').match(/\/products\/([^/?#]+)/);
          if (target && target[1] !== handle) product = await readProduct(decodeURIComponent(target[1]));
        }
        let src = product?.featured_image || product?.images?.[0] || '';
        if (typeof src === 'object') src = src.src || '';
        if (!src) return '';
        if (src.startsWith('//')) src = 'https:' + src;
        return src + (src.includes('?') ? '&' : '?') + 'width=900';
      })());
    }
    return cache.get(handle);
  };
  const markLoaded = (img) => {
    img.closest('.mb-discovery__cover')?.classList.add('is-loaded');
  };
  const repair = (img) => {
    if (!img || img.dataset.mbImageGuard) return;
    const handle = handleOf(img);
    if (!handle) return;
    img.dataset.mbImageGuard = 'pending';
    firstImage(handle).then((src) => {
      if (!src) { img.dataset.mbImageGuard = 'failed'; return; }
      img.dataset.mbImageGuard = 'repaired';
      img.removeAttribute('srcset');
      img.addEventListener('load', () => markLoaded(img), { once: true });
      img.src = src;
    });
  };
  const isBroken = (img) => {
    const src = img.getAttribute('src');
    if (img.dataset.src || img.dataset.srcset || img.getAttribute('loading') === 'lazy' && !img.complete) return false;
    if (!src && !img.getAttribute('srcset')) return Boolean(img.closest('a[href*="/products/"]'));
    return img.complete && img.naturalWidth === 0;
  };
  const scan = () => {
    document.querySelectorAll('a[href*="/products/"] img, [data-product-handle] img').forEach((img) => {
      if (isBroken(img)) repair(img);
    });
  };

  document.addEventListener('error', (event) => {
    if (event.target instanceof HTMLImageElement) repair(event.target);
  }, true);

  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(scan, 1200); };
  const start = () => {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', () => setTimeout(scan, 800));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
